import { render, staticRenderFns } from "./EditModule.vue?vue&type=template&id=0faaa7b2&"
import script from "./EditModule.vue?vue&type=script&lang=js&"
export * from "./EditModule.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports